const generals = {
  none:"None",
  saveStockOrder: "Save stock order",
  addStockOrder: "Add stock order",
  addCargo: "Add cargo",
  warning: "Warning",
  select: "Select",
  free: "Free",
  no_street: "no street",
  typeOfAccount: "Type of registered account",
  returnToLogin: "Return to login",
  haveAccount: "Already have an account?",
  logIn: "Click to log in",
  deleteFile: "Delete file",
  start: "START",
  finish: "FINISH",
  auction_add_success: "Auction added successfully",
  map: "Map",
  auctionList: "Auction list",
  pilotOffers: "Pilot offers",
  techHelp: "Technical support",
  documentVerified: "This document has already been verified",
  policyTo: "Policy valid until",
  vehicleData: "Vehicle data",
  dataBefore: "Previous data",
  dataNow: "Current data",
  existingDriver: "Select existing driver",
  manualDriver: "Enter data manually",
  price: "Flat rate",
  offering: "Offering",
  number_of_days_short: "days",
  radius: "Radius [km]",
  comment: "Comment",
  edit_car: "Edit vehicle",
  mark_all_as_read: "Mark all as read",
  optional: "optional",
  timeFrames: "Time frames",
  main_page: "Home page",
  all: "All",
  invitation_sent: "Invitation sent",
  company_invitation: "Company invitation",
  close: "Close",
  see: "View",
  title: "Title",
  content: "Content",
  unBlock: "Unblock",
  wallet: "Wallet",
  error: "Error",
  return: "Return",
  fold: "Collapse",
  operation: "Operation",
  reserve: "Reserve",
  new: "New",
  add_windows: "Add time windows",
  reservation_success: "Reservation request sent successfully",
  delete: "Delete",
  cmr: "Go to CMR document",
  from_driver: "From carrier",
  for_provision: "For commission",
  "transporting-doc": "Transport order document",
  edit: "Edit",
  loading: "Loading...",
  authorizations: "Authorizations",
  warehouse: "Warehouse",
  monitary_notes: "Notices",
  accepted: "Accepted",
  rejected: "Rejected",
  opening: "Opening",
  closing: "Closing",
  save: "Save",
  saving: "Saving...",
  authorize: "Authorize",
  reject: "Reject",
  block: "Block",
  see_details: "View",
  add: "Add",
  change_workers: "Manage employees",
  add_pics: "Add photos",
  add_avatar: "Add avatar",
  added_avatar: "Avatar added",
  department: "Department",
  actions: "",
  action: "Action",
  workers: "Employees",
  fullName: "Full name",
  elements_visible: "Rows per page",
  notepad: "Notepad",
  message: "Message",
  documents: "Documents",
  true: "True",
  false: "False",
  yes: "Yes",
  no: "No",
  success: "Success",
  successful_edit: "Edited successfully",
  archive: "Finish",
  accept: "Accept",
  added: "Added",
  step: "Step",
  download: "Download",
  go_further: "Continue",
  go: "Go",
  closed: "Closed",
  logout: "Logout",
  tutorial: "Tutorial",
  this_document_will_be_public: "This document will be public",
  language: "Language",
  agreement: "Agreement",
  invoices: "Invoices",
  cancel: "Cancel",
  from: "From",
  to: "To",
  back: "Back",
  search: "Search",
  retreat: "Withdraw",
  phone: "Phone",
  no_id: "No ID",
  no_drivers: "No drivers",
  ignore: "Ignore",
  departments: "Departments",
  verify: "Verify",
  status: "Status",
  chat: "Chat",
  note: "Note",
  details: "Details",
  unfold: "Expand",
  departments_count: "Number of departments",
  warehouse_count: "Number of warehouses",
  change_number: "Edit number",
  change_number_enter: "Enter new phone number",
  refresh: "Refresh",
  home: "Details",
  offer: "Make an offer",
  my_offers: "My offers",
  contact: "Contact",
  data: "Auction",
  auto: "Automatic bidding",
  diary: "Transaction log",
  changelog: "Change log",
  stock_chat: "Send message",
  fullscreen: "Resize",
  for_day: "per day",
  out_of: "of",
  next: "Next",
  leave: "Leave",
  confirm: "Confirm",
  auction_nr: "Auction no.",
  monitory_nr: "Notice no.",
  mine: "Mine",
  generally: "General",
  reservation: "Reservation",
  returning: "Return",
  no_cars: "No cars",
  left: "Left",
  minutes: "min.",
  group_message: "Group message",
  to_group: "To user groups",
  to_specific: "To specific departments",
  chosen_departments: "Selected departments",
  docs: "Company documents",
  data_refreshed: "Data refreshed",
  mark_read: "Mark",
  no_data: "No data",
  creation_date: "Creation date",
  preview: "Preview",
  change: "Change",
  danger: "Warning",
  copy_to_clipboard: "Copy",
  copy_to_clipboard_success: "Copied to clipboard",
  copy_to_clipboard_error: "Failed to copy to clipboard",
  open_chat: "Open chat",
  confirm_action: "Confirm",
  date_expired: "Expired",
  days_helper: "{0} days",
  load: "Load",
  mark_unread: "Mark as unread",
  too_long_title: "Title too long",
  month: "Month",
  year: "Year",
  unavailable: "Unavailable",
  lack: "Lack",
  downloadTimeout: "You must wait a few seconds before downloading files again.",
  pick: "Select",
  downloadableDocuments: "Downloadable documents",
  ofWarehouses: "warehouses",
  ofDepartments: "departments",
  pay: "Pay",
  setProvision: "Set commission for the listing",
  verificationConfirmation: "Are you sure you want to manually verify the company?",
  rating: "Rating",
  send: "Send",
  countWorkers: "Number of employees",
  verificationPendingTitle: "Authorization in progress.",
  verificationDemandTitle: "Authorization required!",
  verificationPendingDesc: "Authorization is being processed.",
  verificationDemandDesc: "To unlock full functionality of the XLplanner.eu platform, please authorize your company.",
  authorizePayment: "Authorize payment",
};
export default generals;
